"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserDetailsCustomAttributes = void 0;
const user_details_1 = require("@app/reducer/user-details");
const store_1 = require("@app/store");
const user_details_custom_attributes_1 = require("../../request/user-details-custom-attributes");
const employee_card_context_1 = require("../employee-card-context");
const useEmployeeCardData_1 = require("./useEmployeeCardData");
const useUserDetailsCustomAttributes = () => {
    const { workspace, employee, userId } = (0, employee_card_context_1.useEmployeeCard)();
    const dispatch = (0, store_1.useRootDispatch)();
    const { mutate, data } = (0, useEmployeeCardData_1.useEmployeeCardData)({
        actionName: 'user-details-custom-attributes',
        requestor: async () => await (0, user_details_custom_attributes_1.requestUserDetailsCustomAttributes)({
            workspaceId: workspace?.id ?? '',
            userId: userId ?? '',
        }),
        reducer: (data) => dispatch((0, user_details_1.setUserCustomAttributes)(data?.customAttributes)),
        selector: (state) => state.userDetails.customAttributes,
        mutator: async (inputData) => await (0, user_details_custom_attributes_1.mutateUserDetailsCustomAttributes)({
            workspaceId: workspace?.id ?? '',
            userId: employee.user?.id ?? '',
            // @ts-expect-error
            data: { customAttributes: inputData },
        }),
        listenDeps: [workspace?.id, userId],
    });
    return [data, mutate];
};
exports.useUserDetailsCustomAttributes = useUserDetailsCustomAttributes;
